export default __webpack_public_path__ + "static/media/Bomba-light.98dfe80c.png";